module.exports = __webpack_public_path__ + "static/img/flag_testerror.3e9bee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flag_testerror.png
// module id = AOtn
// module chunks = 1